module.exports = __webpack_public_path__ + "hopper-fav.png?1817af15e6350701f366f28f37371f97";